import { PathBuilder, routeManager } from '@lib/route-manager';
export function buildAssignmentShareUrl(id, title) {
  var url = new PathBuilder().withBasePath(routeManager.standard.responder.fullPath.assignment.detail.pathParams(id).path).withQueryParam('level', '2').withQueryParam('name', title).build();
  return url;
}